import { useRef, useEffect, useMemo } from "react";
import DmMessage from "./DmMessage";
import { Message, Conversation } from "./dmTypes";

const DMconversation = ({
  conversation,
  image,
  username,
}: {
  conversation: any;
  image: string;
  username: string;
}) => {
  const conversationContainerRef = useRef<HTMLDivElement | null>(null);
  const messagesEndRef = useRef<HTMLDivElement | null>(null);

  const messageMap = useMemo(() => {
    if (!conversation?.messages) return new Map();
    return new Map(
      conversation.messages.map((msg: Message) => [msg.messageID, msg])
    );
  }, [conversation?.messages]);

  const scrollToBottom = () => {
    setTimeout(() => {
      if (conversationContainerRef.current && conversation?.messages) {
        conversationContainerRef.current.scrollTop =
          conversationContainerRef.current.scrollHeight;
      }
    }, 500); //delay so content is rendered
  };

  useEffect(() => {
    scrollToBottom();
  }, [conversation?.messages]);

  // Scroll to the bottom when a new message appears
  useEffect(() => {
    if (messagesEndRef.current && conversation?.messages) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [conversation?.messages?.length]); // Re-run effect when messages length changes

  // Check if conversation or messages are undefined and return a fallback UI
  if (!conversation?.messages) {
    return <div className="ml-2">No direct messages selected.</div>;
  }

  // Sort messages by platformCreatedAt in ascending order (oldest first)
  const sortedMessages = conversation.messages.sort(
    (a: any, b: any) =>
      new Date(a.platformCreatedAt).getTime() -
      new Date(b.platformCreatedAt).getTime()
  );

  return (
    <div
      className="flex-grow mx-2 my-2 overflow-auto"
      ref={conversationContainerRef}
    >
      {sortedMessages.map((message: any, index: number) => (
        <div key={index}>
          <DmMessage
            key={message.messageID}
            image={image}
            text={message.message}
            received={message.sender == username}
            timestamp={message.platformCreatedAt}
            replyTo={message.replyTo}
            attachments={message.attachments}
            getReplyMessage={(replyId: any) => messageMap.get(replyId)}
            isUnsupported={message.isUnsupported}
          />
        </div>
      ))}
      <div ref={messagesEndRef} />{" "}
      {/* This div marks the end of the messages */}
    </div>
  );
};

export default DMconversation;
